<template>
  <div class="pcTabsWarp">
    <div class="buttonLine">
      <div v-if="$route.name != 'orders'" class="buttonRed mr5">
        <el-select v-model="type" @change="changeReType">
          <el-option :value="1" label="个人"></el-option>
          <el-option :value="2" :label="groupLimit"></el-option>
        </el-select>
      </div>
      <div v-else class="buttonWhite mr5" @click="toReservation">{{reservationType == 1 ? '个人' : `${groupLimit}`}}</div>
      <div :class="$route.name == 'orders' ? 'buttonRed' : 'buttonWhite'" @click="toOrders">{{!isNaN(Number($route.query.museumCode)) ? '个人中心' : '我的订单'}}</div>
      <div class="pcToIndex" @click="toIndex">返回</div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      type: ''
    };
  },

  props: ['reservationType'],

  methods: {
    changeReType(val) {
      let query = this.$route.query
      query.type = val
      this.$router.push({path: '/ticket/reservation', query})
    },

    toReservation() {
      let query = this.$route.query
      query.type = this.$route.query.rType || 1
      this.$router.push({path: '/ticket/reservation', query})
    },

    toOrders() {
      // this.type = ''
      if (!isNaN(Number(this.$route.query.museumCode))){
        let query = this.$route.query
        return this.$router.push({name: 'personalCenter', query})
      }
      this.$router.push(`/ticket/orders?museumCode=${this.$cookie.get('museumCode') || this.$route.query.museumCode}&rType=${this.type}`)
    },

    toIndex() {
      let query = this.$route.query
      this.$router.push({path: '/ticket/home', query})
    },

    getTicketDetail() {
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$cookie.get('museumCode') || this.$route.query.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$cookie.get('museumCode') || this.$route.query.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
      })
    }
  },

  created() {
    this.type = this.reservationType
    if (!this.$store.state.ticketDetail.id) {
      this.getTicketDetail()
    }
  },

  computed: {
    groupLimit() {
      return `团队${`${this.$store.state.ticketDetail.orgNumMin ? `(${this.$store.state.ticketDetail.orgNumMin}~${this.$store.state.ticketDetail.orgNumMax})人` : ''}`}`
    }
  }
}
</script>

<style scoped lang="scss">
.pcTabsWarp{
  .buttonLine{
    div{
      display: inline-block;
    }
    margin-bottom: 0.2rem;
    // width: 7rem;
    margin: auto;
    position: relative;
    .mr5{
      margin-right: 0.5rem;
    }
    .pcToIndex{
      position: absolute;
      top: 10px;
      right: 30px;
      width: 63px;
      height: 34px;
      font-size: 16px;
      line-height: 34px;
      padding-left: 25px;
    }
  }
}
</style>
<style type="text/css">
  .buttonLine .el-input__inner{
    height: 56px;
    line-height: 56px;
  }
</style>